const PENDING_GCP_EXTERNAL_ID_KEY = 'pending_gcp_external_id';

function canUseStorage(): boolean {
  return typeof window !== 'undefined';
}

export function savePendingGcpExternalId(externalId: string): void {
  if (!canUseStorage() || !externalId) return;
  window.localStorage.setItem(PENDING_GCP_EXTERNAL_ID_KEY, externalId);
}

export function readPendingGcpExternalId(): string | null {
  if (!canUseStorage()) return null;
  return window.localStorage.getItem(PENDING_GCP_EXTERNAL_ID_KEY);
}

export function clearPendingGcpExternalId(): void {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(PENDING_GCP_EXTERNAL_ID_KEY);
}
